import React, { ComponentType } from 'react';
import { Route, RouteProps } from 'react-router-dom';

import { Grid } from '@mui/material';
import { Spinner } from '@/components/atoms';
import { withAuthenticationRequired } from '@auth0/auth0-react';

interface ProtectedRouteProps extends RouteProps {
  component: ComponentType;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component,
  ...args
}) => (
  <Route
    component={withAuthenticationRequired(component, {
      onRedirecting: () => (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ height: '100%' }}
        >
          <Spinner />
        </Grid>
      ),
    })}
    {...args}
  />
);
